const currency = 'EUR'

function pushEvent(data) {
  if (typeof window.dataLayer !== 'object') return
  window.dataLayer.push(data)
}

function trackNavigation(url) {
  pushEvent({ event: 'navigate', url })
}

function trackNewUserFirstPayment(value) {
  pushEvent({ event: 'new_user_first_payment', value })
}

function trackOnboardingTestingSite(site) {
  pushEvent({ event: 'onboarding_testing_site', label: site })
}

export function trackStartedPlanQuiz() {
  pushEvent({ event: 'onboarding_plan_quiz_start' })
}

export function trackFinishedPlanQuiz(items) {
  pushEvent({ event: 'onboarding_plan_quiz_finish', items })
}

export function trackPlanQuizDecline() {
  pushEvent({ event: 'onboarding_plan_quiz_decline' })
}

export function trackPlanQuizAccept(items) {
  pushEvent({ event: 'onboarding_plan_quiz_accept', items })
}

function trackPurchase(value, coupon, items) {
  pushEvent({
    event: 'purchase',
    currency,
    value,
    coupon,
    items
  })
}

export default {
  trackNavigation,
  trackNewUserFirstPayment,
  trackOnboardingTestingSite,
  trackPurchase
}
